import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BasicInformationStepProps {
  email: string;
  size: string;
  onEmailChange: (email: string) => void;
  onSizeChange: (size: string) => void;
  submitAttempted: boolean;
}

export function BasicInformationStep({
  email,
  size,
  onEmailChange,
  onSizeChange,
  submitAttempted,
}: BasicInformationStepProps) {
  return (
    <Card className="mb-8">
      <CardContent className="p-6">
        <h2 className="text-2xl font-bold font-spartan mb-2">
          Basic Information
        </h2>
        <p className="text-gray-500 mb-4"></p>
        <div className="flex flex-col gap-4 max-w-sm">
          <div className="flex flex-col gap-2">
            <Label htmlFor="email-initial">Email address</Label>
            <Input
              id="email-initial"
              type="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              placeholder="your@email.com"
              required
            />
            {submitAttempted && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) && (
              <span className="text-sm text-red-500">
                Please enter a valid email address
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="size-initial">Quarter Zip Size</Label>
            <Select value={size} onValueChange={onSizeChange}>
              <SelectTrigger id="size-initial">
                <SelectValue placeholder="Choose a size" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="xs">XS</SelectItem>
                <SelectItem value="s">S</SelectItem>
                <SelectItem value="m">M</SelectItem>
                <SelectItem value="l">L</SelectItem>
                <SelectItem value="xl">XL</SelectItem>
                <SelectItem value="xxl">XXL</SelectItem>
                <SelectItem value="xxxl">XXXL</SelectItem>
              </SelectContent>
            </Select>
            {submitAttempted && !size && (
              <span className="text-sm text-red-500">Please select a size</span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
